import { cn } from '@/lib/cn'

/** Compact equalizer; paused playback keeps the bars still. */
export function PlayingIndicator({ animated }: { animated: boolean }) {
  return (
    <span className="inline-flex h-4 w-4 shrink-0 items-end justify-center gap-0.5" aria-hidden="true">
      {[0, 1, 2].map((bar) => (
        <span
          key={bar}
          className={cn('w-0.5 origin-bottom rounded-full bg-accent', ['h-2', 'h-4', 'h-3'][bar], animated && 'playing-bar')}
          style={animated ? { animationDelay: `${bar * -0.23}s` } : undefined}
        />
      ))}
    </span>
  )
}
